// Per-account logo shown in the sidebar so it is obvious which workspace is
// open. Chatwoot only has one installation-wide logo, so this is hard-set by
// account id. Images are served by each brand's own site.
export const ACCOUNT_LOGOS = {
  2: 'https://www.printoracle.com/images/logo-square.png',
  3: 'https://www.tshirtpalace.com/images/logo-mark.png',
};

export const accountLogo = accountId =>
  ACCOUNT_LOGOS[Number(accountId)] ?? null;
